import React from 'react';
import PropTypes from 'prop-types';

import { defineMessages } from 'react-intl';

import BasicLabel from '../../../../components/BasicLabel';

const tooltips = defineMessages({
  GE: {
    id: 'hubs.transfer.transferring-credits.general-education.header',
    defaultMessage: 'General Education',
  },
  'GE text': {
    id: 'hubs.transfer.transferring-credits.general-education.text',
    defaultMessage:
      'General education requirements are designed to give UC undergraduates a broad background in all major academic disciplines: natural sciences, physical sciences, social sciences, humanities and fine arts. The general education requirement, often called the breadth requirement, lists the specific courses they must take or number of credit hours students must earn in each discipline.',
  },
  IGETC: {
    id: 'hubs.transfer.transferring-credits.IGETC-courses.header',
    defaultMessage: 'IGETC',
  },
  'IGETC text': {
    id: 'hubs.transfer.transferring-credits.IGETC-courses.text',
    defaultMessage:
      'The Intersegmental General Education Transfer Curriculum (IGETC) is a series of courses that California community college students can complete to satisfy freshman/sophomore level general education requirements before transferring to most colleges and majors at UC campuses.',
  },
  Breadth: {
    id: 'hubs.transfer.transferring-credits.csu-breadth.header',
    defaultMessage: 'CSU Breadth Course',
  },
  'Breadth text': {
    id: 'hubs.transfer.transferring-credits.csu-breadth.text',
    defaultMessage: `The CSU General Education-Breadth (GE-Breadth) program allows California community college transfer students to fulfill lower-division general education requirements for any California State University (CSU) campus prior to transfer. This curriculum provides an alternative to campus-specific and major-specific IGETC general education requirements and can be a good option if you know you want to transfer to a CSU but don't know which campus you will attend, or if you know which campus you will attend but don't know which major you will pursue.`,
  },
});

export function getCreditTransferPolicies(admissionPolicies) {
  return admissionPolicies.map(transformAdmissionsPolicies);
}

const creditsTransferPoliciesAsWarningRe = /(articulation agreements|manual review)/i;
function transformAdmissionsPolicies(value) {
  return {
    text: value,
    asWarning: creditsTransferPoliciesAsWarningRe.test(value),
  };
}

function extractTooltipKey(value) {
  return value.match(new RegExp(/\b(GE|IGETC|Breadth)\b/, 'i'));
}

export default function CreditTransferPolicies({ intl, creditTransferPolicies }) {
  return creditTransferPolicies.map(({ text, asWarning }, i) => {
    const tooltipKey = extractTooltipKey(text);

    return (
      <BasicLabel
        text={text}
        size={asWarning ? 'small' : 'tiny'}
        className={asWarning ? 'warning' : ''}
        key={text}
        icon={asWarning ? 'warning sign' : 'circle thin'}
        tooltipHeader={
          Array.isArray(tooltipKey) &&
          tooltipKey.length &&
          intl.formatMessage(tooltips[tooltipKey[0]])
        }
        tooltip={
          Array.isArray(tooltipKey) &&
          tooltipKey.length &&
          intl.formatMessage(tooltips[`${tooltipKey[0]} text`])
        }
      />
    );
  });
}

CreditTransferPolicies.propTypes = {
  intl: PropTypes.object,
  creditTransferPolicies: PropTypes.any,
};
